import { User, AlertTriangle } from "lucide-react";
import { useConfigStore } from "../../../store/configStore";
import { UploadArea } from "../components/UploadArea";
import { readFileAsText } from "../../../lib/spineParser";
import { ImportedOutfitConfig } from "../types";
import { applyImportedOutfitToStores } from "../../../lib/outfitFromDrawData";

interface OutfitUploaderProps {
  onSuccess: () => void;
}

export function OutfitUploader({ onSuccess }: OutfitUploaderProps) {
  const { templateConfig, currentTid } = useConfigStore();

  const handleImportOutfit = async (file: File) => {
    try {
      const outfitText = await readFileAsText(file);
      const outfit = JSON.parse(outfitText) as ImportedOutfitConfig;

      const fallbackMain =
        (templateConfig as { id?: string } | null)?.id || currentTid || "";
      const result = applyImportedOutfitToStores(outfit, fallbackMain);
      if (result.ok === false) {
        alert(result.message);
        return;
      }

      onSuccess();
    } catch (err) {
      alert(`导入失败: ${err instanceof Error ? err.message : "未知错误"}`);
    }
  };

  return (
    <div className="flex-1 min-h-0 flex flex-col h-full">
      <div className="mb-4 rounded-lg border border-amber-200 bg-amber-50 p-4 shrink-0">
        <div className="flex gap-2">
          <AlertTriangle className="h-4 w-4 text-amber-600 mt-0.5 shrink-0" />
          <p className="text-sm text-amber-800">
            导入搭配文件将更新当前选中的皮肤、染色和动画。
          </p>
        </div>
      </div>
      <UploadArea
        icon={<User className="h-12 w-12 mx-auto mb-4 text-cyan-500" />}
        description="拖拽文件到此处上传"
        fileHint="支持 .json 文件（搭配文件）"
        accept={{ "application/json": [".json"] }}
        onDrop={(files) => {
          const fileList = Array.from(files);
          const jsonFile = fileList.find((f) => f.name.toLowerCase().endsWith(".json"));
          if (jsonFile) {
            handleImportOutfit(jsonFile);
          } else {
            alert("请拖拽 .json 文件");
          }
        }}
      />
    </div>
  );
}
